import { createApiCallActions } from '../../../common/store/generic.actions';
import { ListItem } from '../typeahead/types';

export const groupActions = {
  getListItem: createApiCallActions<ListItem[]>('group', 'getListItem'),
};

export type GroupAction = typeof groupActions;
